import { render, staticRenderFns } from "./ProductScoring.vue?vue&type=template&id=08543e32&lang=pug&"
import script from "./ProductScoring.vue?vue&type=script&lang=js&"
export * from "./ProductScoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports